import {
    USER_AUTHENTICATE_SUCCESS_ACTION,
    USER_AUTHENTICATE_BEGIN_ACTION,
    USER_AUTHENTICATE_FAIL_ACTION,
    USER_LOGOUT_ACTION
} from "../constants";
import axios from 'axios';
import history from 'middlewares/history';
import {
    AUTH_BASE_URL
} from '../config';

const BASE_URL = `${AUTH_BASE_URL}`;

export const requestLogin = facet => ({
    type: USER_AUTHENTICATE_BEGIN_ACTION,
    facet,
    meta: {
        throttle: true
    }
});

export const receiveLogin = (token) => ({
    type: USER_AUTHENTICATE_SUCCESS_ACTION,
    token
});

export const receiveLoginFail = (error) => ({
    type: USER_AUTHENTICATE_FAIL_ACTION
});

export const receiveLogout = () => ({
    type: USER_LOGOUT_ACTION
});

export const login = (username, password, search='') => dispatch => {
    dispatch(requestLogin());

    const url = `${BASE_URL}/login`,
        payload = {
            username,
            password
        };

    return axios.post(url, payload, {
        withCredentials: true,
    })
        .then(response => {
            const authenticated = response && !(response.message && response.message.indexOf && response.message.indexOf('error'));
            if (authenticated) {
                if (search !== '')
                    history.push(`/${search}`);
                else
                    history.push(`/`);
                return dispatch(receiveLogin(response.data));
            }
            else
                dispatch(receiveLoginFail(response))
        })
        .catch(error => dispatch(receiveLoginFail(error)));

};

export const logout = () => dispatch => {
    const //cookie = document.cookie,
        url = `${BASE_URL}/logout`;

    document.cookie = `page=;path=/`; //clear cookie
    history.push(`/login-page`);

    axios.post(url,{})
        .then(response => {
            return dispatch(receiveLogout());
        })
        .catch(error => dispatch(receiveLogout()));

};

export function redirectToLogin(target='') {
    history.push(`/login-page${target}`);
}




// WEBPACK FOOTER //
// ./src/actions/user.js